import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { InformesService } from 'app/services/informes.service';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';

@Component ({
  selector: 'app-modaltitulares',
  templateUrl: './modaltitulares.component.html',
  styleUrls: ['./modaltitulares.component.scss']
})
export class ModaltitularesComponent implements OnInit {
  
  //DataTable
  public dtOptions;
  public tableOpt;
  @ViewChild(DataTableDirective, {static:true})
  tabla: DataTableDirective;
  public dtTrigger: Subject<void>

  constructor(@Inject(MAT_DIALOG_DATA) private data, private _informe: InformesService, private dialog: MatDialog) {
    this.dtTrigger = new Subject();

    this.tableOpt = [];
    this.dtOptions = {
      columns: [
        {
          title:''
        },
        {
          title:'promeServAde',
          data:'promeServAde'
        },
        {
          title:'servAdeTotal',
          data:'servAdeTotal'
        },
        {
          title:'Meses',
          data:'PerTiempoBen'
        },
        {
          title:'Documento',
          data:'bendoc'
        },
        {
          title:'Nombre',
          data:'bennom'
        },
        {
          title:'Total Servicios',
          data:'total_servicios'
        },
        {
          title:'Radicado',
          data:'grugru'
        },
        {
          title:'IDtitular',
          data:'ID_Titular'
        },
        {
          title:'IDgrupo',
          data:'ID_Grupo'
        },
        {
          title:'Ingreso',
          data:'bening'
        },
        {
          title:'Telefono',
          data:'bentel'
        }
      ]
    }
  }
  
  ngOnInit() {
    console.log(this.data);
    this._informe.BeneficiariosdeunTitular(this.data.fechaInicial,this.data.fechaFinal,this.data.titular_doc).subscribe((data:any) => {
      this.tableOpt = data.resultado;
      this.dtTrigger.next();
    });
  }

}
